module.exports = __webpack_public_path__ + "static/media/publishing_image3.64ec6530.webp";